"use strict";

(function () {
  'use strict';

  function groupByFilter() {
    return function (collection, key) {
      if (!Array.isArray(collection) || !key) {
        return collection;
      }

      return collection.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    };
  }

  groupByFilter.$inject = [];
  angular.module('filter.group-by', []).filter('groupBy', groupByFilter);
})();